import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Shared page title + subtitle used across redesigned app pages.
 */
export default function PageHeader({ title, subtitle, actions, className, eyebrow }) {
  return (
    <div className={cn('flex items-start justify-between mb-6 gap-4', className)}>
      <div>
        {eyebrow ? <p className="mb-2 text-xs font-mono uppercase tracking-[0.16em] text-mute">{eyebrow}</p> : null}
        <h1 className="text-3xl font-extrabold text-ink mb-2 tracking-tight">{title}</h1>
        {subtitle ? <p className="text-mute">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex-shrink-0">{actions}</div> : null}
    </div>
  );
}
